import styled from "styled-components";
import CompetencyModal from "../../components/CompetencyModal";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { ClickableIcon } from "../../components/Icon";
import Modal from "../../components/Modal";
import MinimalSelect from "../../components/MinimalSelect";
import Button from "../../components/Button";
import Status from "../../types/enum/Status";
import theme from "../../styles/theme";
import { Icon as MuiIcon } from "@mui/material";
import { useState } from "react";

const Header = styled.h4`
  //   font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  //   line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
  display: flex;
  align-item: center;
  gap: 2;
`;

interface Props {
  setOpen: (x: boolean) => void;
  isOpen: boolean;
  versionOption: Array<{ label: string; value: number }>;
  saveClone: (targetVersion: { label: string; value: number }) => void;
}
export const CloneCompetencyModal = (props: Props) => {
  const { setOpen, isOpen, versionOption, saveClone } = props;
  const [selectedVersion, setSelectedVersion] = useState({
    label: "",
    value: 0,
  });

  return (
    <Modal
      customStyle={{
        content: {
          maxWidth: "450px",
          color: "black",
          padding: 20,
        },
      }}
      isOpen={isOpen}
      setOpen={setOpen}
    >
      <FlexBox>
        <FlexGrow>
          <Header>
            <MuiIcon
              sx={{
                color: "green",
                marginRight: "10px",
                // textShadow: "0 2px 4px #8080807a",
              }}
            >
              file_copy
            </MuiIcon>
            Clone Competency
          </Header>
        </FlexGrow>
        <ClickableIcon
          color="black"
          name="close"
          onClick={() => setOpen(false)}
        />
      </FlexBox>

      {versionOption?.length===0?
      <FlexBox style={{ marginTop: 20, background: '#f3f3f3',padding:"50px 20px",borderRadius:5 }}>   <MuiIcon
              sx={{
                color: "#007cdf",
                marginRight: "10px",
                // textShadow: "0 2px 4px #8080807a",
              }}
            >
              info
            </MuiIcon>No target draft version available for cloning</FlexBox>:
      <FlexBox>
        <span style={{ marginTop: 20 }}>Choose the version to clone into:</span>
        <MinimalSelect
          onChange={(e: any) => setSelectedVersion(e)}
          options={versionOption}
          styles={{
            container: (base) => ({
              ...base,
              marginTop: 10,
              width: "100%",
              maxWidth: "100%",
            }),
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
              // color: theme.color.lightBlueGray800,
            }),
          }}
        />
        <span style={{ fontSize: 14, color: "gray", marginTop: 20 }}>
          This will create a duplicate in selcted version.
        </span>
        <FlexBox justify="end" style={{ width: "100%", marginTop: 20 }}>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            status={Status.button}
          >
            Cancel
          </Button>
          <Button
            disabled={!selectedVersion.label}
            onClick={() => saveClone(selectedVersion)}
            style={{
              //   width: 110,
              whiteSpace: "nowrap",
              background: theme.color.greenButton,
              color: "white",
              boxShadow: "0 2px 5px #808080cc",
              border: "none",
            }}
            status={Status.button}
          >
            Clone Competency
          </Button>
        </FlexBox>
      </FlexBox>}
    </Modal>
  );
};
